import logo from './logo.svg';
import logoWhite from './logo-white.svg';
import amex from './amex.svg';
import jcb from './jcb.svg';
import applepay from './apple-pay.svg';
import googlepay from './google-pay.svg';
import shop from './shop.svg';
import mastercard from './mastercard.svg';
import visa from './visa.svg';

const LogoImages = {
    logo, logoWhite, amex, jcb, applepay, googlepay, shop, mastercard, visa
};

export default LogoImages;
